import * as React from "react";

import "./office-layout.scss";

import {consumeContext} from "@Common/react/context";
import {cs} from "@Common/react/chain-services";

import {AccountTabsLayout} from "../../common/account-tabs-layout/account-tabs-layout";

export const OfficeLayout = ({activeTab, next}) => cs(
    consumeContext("accountMenu"),
    consumeContext("apis"),
    ({accountMenu}, next) => AccountTabsLayout({
        activeMenu: "office",
        activeTab,
        config: accountMenu?.["officeMenu"]?.subMenu ?? items,
        next,
    }),
    () => (
        <div className="office-layout-cf2">
            {next()}
        </div>
    ),
);

const items = [
    {
        linkLabel: "Office Info",
        name: "office-info",
        link: "/account/office/office-info",
    },
    {
        linkLabel: "Address Book",
        name : "office-address-book",
        link: "/account/office/address-book",
    },
];
